import React, { useContext, useEffect, useMemo, useState } from 'react'
import StoresHeader from '../../Components/Stores/StoresHeader'
import styles from './StoreClients.module.css'
import { Link } from 'react-router-dom'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import { toast, ToastContainer } from 'react-toastify'
import { IoMdEye } from 'react-icons/io'
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa'
import { convertDateToDdMmYyyy } from '../../Helper/calculations'

const StoreClients = () => {
    const asCtx = useContext(ActiveStoreContext)
    const authCtx = useContext(AuthContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const [allUsers, setAllUsers] = useState([
        {
            client_name: 'Loading...',
            countryCode: '+91',
            mobile: 'Loading...',
            email: 'Loading...',
            dob: 'Loading...',
            doa: 'Loading...'
        },
        {
            client_name: 'Loading...',
            countryCode: '+91',
            mobile: 'Loading...',
            email: 'Loading...',
            dob: 'Loading...',
            doa: 'Loading...'
        },
        {
            client_name: 'Loading...',
            countryCode: '+91',
            mobile: 'Loading...',
            email: 'Loading...',
            dob: 'Loading...',
            doa: 'Loading...'
        },
        {
            client_name: 'Loading...',
            countryCode: '+91',
            mobile: 'Loading...',
            email: 'Loading...',
            dob: 'Loading...',
            doa: 'Loading...'
        }
    ]);
    const [filteredData, setFilteredData] = useState([])
    const [searchKey, setSearchKey] = useState('')
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' })

    const getClientsStats = async () => {
        const response = await fetch(BASE_URL_API + "getClientsData",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx?.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error!")
        } else {
            const respo = await response.json();
            if (respo.status === "success") {
                setAllUsers(respo.response)
                setFilteredData(respo.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout();
                } else {
                    console.log(respo);
                    setAllUsers([])
                    setFilteredData([])
                }
            }
        }
    }

    const filterData = (data, searchKey) => {
        const keyword = searchKey.trim().toLowerCase()
        if (!keyword) {
            setFilteredData(Array.isArray(data) ? data : [])
            return
        }
        setFilteredData((Array.isArray(data) ? data : []).filter(item =>
            Object.values(item || {}).some(value =>
                value?.toString().toLowerCase().includes(keyword)
            )
        ))
    }

    useEffect(() => {
        filterData(allUsers, searchKey)
    }, [allUsers, searchKey])


    useEffect(() => {
        if (activeStore !== null) {
            getClientsStats()
        }
    }, [activeStore?.storeIdentifier])

    const getSortValue = (item, key) => {
        switch (key) {
            case 'clientName':
                return item?.clientName?.toString().toLowerCase() || ''
            case 'clientGender':
                return item?.clientGender?.toString().toLowerCase() || ''
            case 'mobile': {
                const country = (!item?.countryCode || item.countryCode.trim().toLowerCase() === 'null' || item.countryCode.trim().toLowerCase() === 'undefined')
                    ? '+91'
                    : item.countryCode
                return `${country}-${item?.mobile || ''}`
            }
            case 'dob': {
                const dateStr = item?.dob ? item.dob.substring(0, 10) : ''
                const date = new Date(dateStr)
                return Number.isNaN(date.getTime()) ? Number.NEGATIVE_INFINITY : date.getTime()
            }
            case 'createdOn': {
                const created = item?.createdOn || item?.addedOn || ''
                const date = new Date(created)
                return Number.isNaN(date.getTime()) ? Number.NEGATIVE_INFINITY : date.getTime()
            }
            default:
                return ''
        }
    }

    const sortedData = useMemo(() => {
        if (!Array.isArray(filteredData)) {
            return []
        }

        if (!sortConfig.key) {
            return filteredData
        }

        const sorted = [...filteredData].sort((a, b) => {
            const aValue = getSortValue(a, sortConfig.key)
            const bValue = getSortValue(b, sortConfig.key)

            if (aValue === bValue) {
                return 0
            }

            if (aValue === '' || aValue === Number.NEGATIVE_INFINITY) {
                return 1
            }

            if (bValue === '' || bValue === Number.NEGATIVE_INFINITY) {
                return -1
            }

            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1
            }

            return sortConfig.direction === 'asc' ? -1 : 1
        })

        return sorted
    }, [filteredData, sortConfig])

    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                return {
                    key,
                    direction: prev.direction === 'asc' ? 'desc' : 'asc'
                }
            }
            return { key, direction: 'asc' }
        })
    }

    const renderSortIcon = (key) => {
        const iconClass = sortConfig.key === key ? `${styles.sortIcon} ${styles.sortIconActive}` : styles.sortIcon

        if (sortConfig.key !== key) {
            return <FaSort className={iconClass} />
        }

        return sortConfig.direction === 'asc'
            ? <FaSortUp className={iconClass} />
            : <FaSortDown className={iconClass} />
    }

    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <StoresHeader />
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        <div className={styles.mainHeader}>
                            Please select a store!
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.mainWrapper}>
            {/* <StoresHeader /> */}
            <div className={styles.mainContainer}>
                <div className={styles.mainContent}>
                    <div className={styles.mainHeader}>
                        <div className={styles.subTitle}>
                            <div className={styles.tableTitle}>
                                <div className={styles.tableSearch}>
                                    <input placeholder="Search for anything... " value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                                </div>
                                <div className={styles.resultsCount}>
                                    {filteredData?.length || 0} client(s) found!
                                </div>
                            </div>
                        </div>
                        <div className={styles.addNew}>
                            <Link to={`/add-clients`} >+ Add A New Client</Link>
                        </div>
                    </div>
                    <div className={styles.mainBody}>
                        <div className={styles.tableWrapper}>
                            <div className={styles.tableHeader}>
                                <div className={styles.tCount}>#</div>
                                <div
                                    className={`${styles.tFullname} ${styles.sortableHeader}`}
                                    onClick={() => handleSort('clientName')}
                                >
                                    <span>Full Name</span>
                                    {renderSortIcon('clientName')}
                                </div>
                                <div
                                    className={`${styles.tPhone} ${styles.sortableHeader}`}
                                    onClick={() => handleSort('clientGender')}
                                >
                                    <span>Gender</span>
                                    {renderSortIcon('clientGender')}
                                </div>
                                <div
                                    className={`${styles.tPhone} ${styles.sortableHeader}`}
                                    onClick={() => handleSort('mobile')}
                                >
                                    <span>Phone</span>
                                    {renderSortIcon('mobile')}
                                </div>
                                {/* <div className={styles.tEmail}>E-mail</div> */}
                                <div
                                    className={`${styles.tBirthdate} ${styles.sortableHeader}`}
                                    onClick={() => handleSort('dob')}
                                >
                                    <span>Birthdate</span>
                                    {renderSortIcon('dob')}
                                </div>
                                <div
                                    className={`${styles.tAnniversary} ${styles.sortableHeader}`}
                                    onClick={() => handleSort('createdOn')}
                                >
                                    <span>Registered On</span>
                                    {renderSortIcon('createdOn')}
                                </div>
                                <div className={styles.tAction}>Action</div>
                            </div>
                            <div className={styles.tableData}>
                                {sortedData?.map((item, index) => (
                                    <Link 
                                        to={`/user/${item?.clientStoreRelationIdentifier}`}
                                        className={styles.eachTableRow} key={index} 
                                    >
                                        <div className={styles.tCount}>{index + 1}.</div>
                                        <div className={styles.tFullname}>{item?.clientName}</div>
                                        <div className={styles.tPhone}>{item?.clientGender}</div>
                                        <div className={styles.tPhone}>
                                            {(!item?.countryCode || item.countryCode.trim().toLowerCase() === "null" || item.countryCode.trim().toLowerCase() === "undefined")
                                                ? "+91"
                                                : item.countryCode
                                            }
                                            -{item?.mobile}
                                        </div>

                                        {/* <div className={styles.tEmail}>{item?.email}</div> */}
                                        <div className={styles.tBirthdate}>{convertDateToDdMmYyyy(item?.dob?.substring(0, 10))!=='Invalid date. Please provide a valid date string.' ? convertDateToDdMmYyyy(item?.dob?.substring(0, 10)) : 'NA'}</div>
                                        <div className={styles.tAnniversary}>{item?.createdOn || item?.addedOn }</div>
                                        <div className={styles.tAction}>
                                            <Link to={`/user/${item?.clientStoreRelationIdentifier}`}
                                                className={styles.viewBtn}
                                                title="View Full Details"
                                            >
                                                <IoMdEye color="#1d7af4" size={18} />
                                            </Link>
                                            
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default StoreClients